import ArrowRight16 from '@carbon/icons-react/es/arrow--right/16';
import Edit16 from '@carbon/icons-react/es/edit/16';
import { Col, Row, Space } from 'antd';
import React, { FC, useState } from 'react';
import { Button } from 'components/atoms/button';
import { Form } from 'components/atoms/form';
import { Input } from 'components/atoms/input';
import { useTranslation } from 'hooks/use-translation';
import { removeURLProtocols } from 'utils/transform-url';
import { URlRegEx } from 'utils/urls';
import { SettingsLabel } from '../styles';

export const AddCustomDomain: FC<{
  onAdd: (domain: string) => void;
  loading?: boolean;
  domain?: string;
}> = ({ onAdd, loading = false, domain = undefined }) => {
  const [form] = Form.useForm();
  const [disableEdit, setDisableEdit] = useState<boolean>(!!domain);

  const changeText = useTranslation('change');
  const defaultButtonText = useTranslation('setup_url');
  const loadingText = useTranslation('setting_up');
  const title = useTranslation('settings.custom_domain.new.title');
  const validationMessage = useTranslation('input.url');

  const onSubmit = () => {
    const formValues = form.getFieldsValue(true);
    const transformedDomain = removeURLProtocols(formValues.domain);

    return onAdd(transformedDomain);
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <SettingsLabel>{title}</SettingsLabel>
        </Col>
        <Col span={14}>
          <Form
            layout="vertical"
            form={form}
            requiredMark={false}
            onFinish={onSubmit}
            initialValues={{ domain }}
          >
            <Space size={0}>
              <Form.Item
                name="domain"
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    pattern: URlRegEx,
                    message: validationMessage,
                  },
                ]}
              >
                <Input
                  placeholder="onboarding.acme.com"
                  disabled={disableEdit}
                />
              </Form.Item>
              <Form.Item shouldUpdate hidden={disableEdit}>
                {() => (
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<ArrowRight16 />}
                    iconPlacement="right"
                    disabled={
                      !form.isFieldsTouched(true) ||
                      !!form
                        .getFieldsError()
                        .filter(({ errors }) => errors.length).length
                    }
                    loading={loading}
                  >
                    {loading ? loadingText : defaultButtonText}
                  </Button>
                )}
              </Form.Item>
              <Form.Item shouldUpdate hidden={!disableEdit}>
                {() => (
                  <Button
                    type="primary"
                    icon={<Edit16 />}
                    iconPlacement="right"
                    onClick={() => setDisableEdit(false)}
                  >
                    {changeText}
                  </Button>
                )}
              </Form.Item>
            </Space>
          </Form>
        </Col>
      </Row>
    </>
  );
};
